import { formatDate } from '../../../helpers/common'


const DateTimeCell = ({ dateTime, withTime = true }) => <span>{formatDate(dateTime, withTime)}</span>

export default DateTimeCell